//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import handleErrorMixin from '@/mixins/handleErrorMixin'
import notificationMixin from '@/mixins/notificationMixin'
import ProjectTabsAddUsersWithoutMassiveImport from '@/components/Projects/NewProjectSteps/shared/ProjectTabsAddUsersWithoutMassiveImport.vue'
import ProjectActionsContainer from '@/components/Projects/NewProjectSteps/shared/ProjectActionsContainer.vue'
import Button from '@/components/Shared/Button.vue'
import AddNewUserForm from '@/components/Projects/NewProjectSteps/shared/TabNewUsers/AddNewUserForm.vue'
import ProjectModalAddUsers from '~/components/Projects/NewProjectSteps/shared/ProjectModalAddUsers.vue'
import TabAddNewUsersWithoutMassiveImport from '~/components/Projects/NewProjectSteps/shared/TabNewUsers/TabAddNewUsersWithoutMassiveImport.vue'
import TabAddRegisteredUsers from '~/components/Projects/NewProjectSteps/shared/TabRegisteredUsers/TabAddRegisteredUsers.vue'
import PROJECT_VALIDATION_STATUS from '~/constants/project-validation-status'
const SEND_INVITATION = false
const TAB_ADD_REGISTERED_USERS = 0
const TAB_ADD_NEW_USER = 1
export default {
  components: {
    ProjectModalAddUsers,
    ProjectTabsAddUsersWithoutMassiveImport,
    ProjectActionsContainer,
    Button,
    TabAddNewUsersWithoutMassiveImport,
    TabAddRegisteredUsers,
    AddNewUserForm,
  },
  mixins: [handleErrorMixin, notificationMixin],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    employees: {
      type: Array,
      default: () => [],
    },
    supervisors: {
      type: Array,
      required: false,
      default: () => [],
    },
    projectId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isShow: this.value,
      tab: 0,
      isValidForm: false,
      newUserToAdd: null,
      existedUsersToAddIds: [],
      keepOpenAfterSubmit: false,
      addUserFormKey: 0,
      supervisor: null,
      isSupervisorRequired: false, // Nueva propiedad para controlar la validación del supervisor
      isLoadingForm: false,
    }
  },
  computed: {
    employeesWithStatus() {
      return this.employees.map((employee) => ({
        ...employee,
        isSelectable: this.isSelectableUser(employee),
        tag: this.getUserOptionTab(employee),
      }))
    },
    isEnabledButtonConfirm() {
      return (
        (this.tab === TAB_ADD_REGISTERED_USERS &&
          this.existedUsersToAddIds.length > 0) ||
        (this.tab === TAB_ADD_NEW_USER &&
          this.isValidForm &&
          (!this.isSupervisorRequired || this.supervisor !== null))
      )
    },
    supervisorsFormatted() {
      return this.supervisors.map((supervisor) => ({
        value: supervisor.id,
        names: `${supervisor.names} ${supervisor.lastnames}`,
      }))
    },
  },
  watch: {
    isShow(newValue) {
      this.tab = 0
      this.$emit('input', newValue)
      if (!newValue) {
        this.reset()
      }
    },
    value(newValue) {
      this.tab = 0
      this.isShow = newValue
      if (!newValue) {
        this.reset()
      }
    },
  },
  methods: {
    isSelectableUser(user) {
      if (!user.identification_number) {
        return false
      }
      if (user.projectRole) {
        return !(
          user?.projectRole?.project === this.projectId &&
          user?.projectRole?.deleted_at === null
        )
      }
      return !user.project
    },
    getUserOptionTab(user) {
      if (!user.identification_number) {
        return 'RUT no registrado'
      }
      if (!user.projectRole) {
        return null
      }
      return user?.project?.id === this.projectId ||
        (user?.projectRole?.project === this.projectId &&
          user?.projectRole?.deleted_at === null)
        ? 'Pertenece al proyecto'
        : null
    },
    reset() {
      this.addUserFormKey += 1
      this.isValidForm = false
      this.newUserToAdd = null
      this.existedUsersToAddIds = []
      this.supervisor = null
    },
    handleClickConfirm() {
      if (this.tab === TAB_ADD_REGISTERED_USERS) {
        this.addExistedUsers()
      }
      if (this.tab === TAB_ADD_NEW_USER) {
        this.handleConfirmAddNewUserTab()
      }
    },
    handleClickConfirmAndOther() {
      this.keepOpenAfterSubmit = true
      this.handleConfirmAddNewUserTab()
    },
    async handleConfirmAddNewUserTab() {
      this.isLoadingForm = true
      try {
        await this.saveNewUser()
      } catch (error) {
        this.handleError(error, 'Error al agregar usuario')
        this.$emit('user-with-error', error.message)
      } finally {
        this.isLoadingForm = false
      }
    },
    getFormatedUser() {
      const user = { ...this.newUserToAdd, project_id: this.projectId }
      delete user.repeatEmail
      if (!user.email) {
        delete user.email
      }
      return user
    },
    handlePostSubmit() {
      this.reset()
      this.$emit('refresh-employees')
      if (!this.keepOpenAfterSubmit) {
        this.isShow = false
      }
      this.keepOpenAfterSubmit = false
    },
    async saveNewUser() {
      const user = this.getFormatedUser()
      const response = await this.$repository.invitation.newSingleCreateCollaborators(
        {
          user,
          sendInvitation: SEND_INVITATION,
        }
      )
      if (this.isSupervisorRequired) {
        await this.$repository.supervisorAssignments.saveMassiveCollaborators({
          collaboratorsIds: [response.id],
          supervisorId: this.supervisor?.value,
          projectId: this.projectId,
          validationStatus: PROJECT_VALIDATION_STATUS.PENDING,
          sendInvitationEmail: true,
        })
      }
      this.successNotification('Colaborador agregado correctamente')
      this.handlePostSubmit()
    },

    async addExistedUsers() {
      try {
        await this.$repository.invitation.addExistingCollaboratorsToProjectAndNotify(
          {
            projectId: this.projectId,
            usersIds: this.existedUsersToAddIds,
            sendInvitation: SEND_INVITATION,
          }
        )
        this.successNotification('Colaboradores agregados correctamente')
        this.handlePostSubmit()
      } catch (error) {
        this.handleError(error, 'Error al agregar colaboradores')
      }
    },
  },
}
